import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { ShopInfo } from './CpfModel';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    getProvinceList: function () {
        const url = this.config().bzbsModuleUrl + '/main/provinces';
        return BzbsApi.connectBzbsGet(url);
    },
    getShopByProvince: function (provinceName) {
        const params = {
            province: provinceName
        }
        const url = this.config().bzbsModuleUrl + '/main/shops';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, null, params)
                .then(response => {
                    let list = [];
                    for (let item of response.data) {
                        list.push(new ShopInfo(item));
                    }

                    resolve(list);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}
